// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"98f334b5","498":"460bff2a","598":"af63fb11","703":"780faa6b","787":"7922278b"}[chunkId] + ".chunk.js";
};